import { useCallback } from 'react';
import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { PATHS } from '@/common';

interface LinkTokenResponse {
  link_token: string;
}

const useGetPlaidLinkTokenQuery = (accountId?: string, redirectUri?: string) => {
  const { mutateAsync, isLoading, isSuccess, isError } = useMutation(
    () =>
      api.post<LinkTokenResponse>(
        PATHS.GET_PLAID_LINK_TOKEN,
        {},
        {
          params: {
            ...(accountId ? { account_id: accountId } : {}),
            ...(redirectUri ? { redirect_uri: redirectUri } : {}),
          },
        }
      ),
    {
      retry: 0,
    }
  );

  const getPlaidLinkToken = useCallback(async () => {
    const response = await mutateAsync();
    return response?.data?.link_token;
  }, [mutateAsync]);

  return {
    getPlaidLinkToken,
    isLoading,
    isSuccess,
    isError,
  };
};

export default useGetPlaidLinkTokenQuery;
